(function () {
  function emitSearch(query) {
    document.dispatchEvent(
      new CustomEvent("diagnox:help-search", {
        bubbles: true,
        detail: { query: query || "" }
      })
    );
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  var sections = document.querySelectorAll("[data-section-type='custom-help-search']");
  if (!sections.length) return;

  sections.forEach(function (section) {
    var form = section.querySelector("[data-help-search-form]");
    var input = section.querySelector("[data-help-search-input]");
    if (!form || !input) return;

    var runSearch = debounce(function () {
      emitSearch(input.value);
    }, 150);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      emitSearch(input.value);
    });

    input.addEventListener("input", runSearch);
    input.addEventListener("search", function () {
      emitSearch(input.value);
    });

    section.querySelectorAll("[data-help-search-query]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var query = pill.getAttribute("data-help-search-query") || "";
        input.value = query;
        input.focus();
        emitSearch(query);
      });
    });
  });
})();